import { render, staticRenderFns } from "./propertyCategoryForm.vue?vue&type=template&id=14e46344&%23default=true&"
import script from "./propertyCategoryForm.vue?vue&type=script&lang=js&"
export * from "./propertyCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports